// Set through the CSSOM: writing a style attribute is blocked by the Content-Security-Policy.
export default function(element) {
  const initialDisplay = window.getComputedStyle(element, null).display;
  element.style.setProperty("display", "none", "important");
  return initialDisplay;
}
